import React from "react";
import styles from "./styles.css";
const appleStoreIcon = require("../../assets/AppleStore.png");
const googlePlayIcon = require("../../assets/GooglePlay.png");
function StoreLinks({ appStoreUrl, playMarketUrl }) {
    return (React.createElement("section", { className: styles.container },
        React.createElement("a", { href: appStoreUrl, className: styles.link, target: "_blank", rel: "nofollow noopener" },
            React.createElement("img", { src: appleStoreIcon, alt: "App Store" })),
        React.createElement("a", { href: playMarketUrl, className: styles.link, target: "_blank", rel: "nofollow noopener" },
            React.createElement("img", { src: googlePlayIcon, alt: "Google Play" }))));
}
;
export default StoreLinks;
